export class NewPOSUtil {
  static NewPOSEnum = {
    machineName: "machineName",
    operatorId: "operatorId",
    deviceId: "deviceId",
    machineGroup: "machineGroup",
    address: "address",
    streetNumber: "streetNumber",
    country: "country",
    zipCode: "zipCode",
    city: "city",
    note1: "note1",
    longitude: "longitude",
    latitude: "latitude",
    note2: "note2",
  };

  static BulkFileEnum = {
    csvFile: "csvFile",
  };
}

export const addMoreZeroes = (number) => {
  if(number) return number?.length <= 4 ? "0" + parseInt(number) : number;
};
export const threeDigitNum = (number) => {
  if(number) return number?.length <= 1 ? "00" + parseInt(number) : "0" + parseInt(number);
};
